import { all, call, put, takeEvery } from 'redux-saga/effects';
import actions from '../actions';
import VendorHttpService from '../../services/vendor.http';

export function* GET({ payload }) {
  yield put({
    type: actions.vendor.SET_STATE,
    payload: { loading: true }
  });

  const response = yield call(VendorHttpService.get, payload);

  if (response) {
    if (response.status === 200) {
      yield put({
        type: actions.vendor.SET_STATE,
        payload: { selected_vendor: response.data }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.vendor.SET_STATE,
    payload: { loading: false }
  });
}

export function* GET_OF_EVENT({ payload }) {
  yield put({
    type: actions.vendor.SET_STATE,
    payload: { loading: true }
  });

  const response = yield call(
    VendorHttpService.get,
    payload.vendor_uid,
    payload.marketplace_uid
  );

  if (response) {
    if (response.status === 200) {
      yield put({
        type: actions.vendor.SET_STATE,
        payload: { selected_vendor: response.data }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.vendor.SET_STATE,
    payload: { loading: false }
  });
}

export function* LIST_OF_EVENT({ payload }) {
  yield put({
    type: actions.vendor.SET_STATE,
    payload: { vendors: [], loading: true }
  });

  const response = yield call(VendorHttpService.listOfEvent, payload);

  if (response) {
    if (response.status === 200) {
      yield put({
        type: actions.vendor.SET_STATE,
        payload: { vendors: response.data }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.vendor.SET_STATE,
    payload: { loading: false }
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.vendor.GET, GET),
    takeEvery(actions.vendor.GET_OF_EVENT, GET_OF_EVENT),
    takeEvery(actions.vendor.LIST_OF_EVENT, LIST_OF_EVENT)
  ]);
}
